import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { environment } from 'src/environments/environment';
import { CreateTicketData, Ticket } from 'src/app/models/core/ticket.model';

@Injectable({
  providedIn: 'root'
})
export class TicketActionsApiService {

  private readonly baseUrl = `${environment.api_server}/api`;

  constructor(
    private readonly http: HttpClient,
    private readonly _api: ApiService
  ) { }


  sendEditPetition(body: any): Observable<any> {
    const url = `${this.baseUrl}/petitions`;
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers => this.http.post(url, body, { headers }))
    );
  }

  sendDeletePetition(body: any): Observable<any> {
    const url = `${this.baseUrl}/petitions`;
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers => this.http.post(url, body, { headers }))
    );
  }

  deleteTicket(ticketId: number): Observable<any> {
    const url = `${this.baseUrl}/sellers/tickets/${ticketId}`;
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers => this.http.delete(url, { headers }))
    );
  }

  generateTicket(ticketData: CreateTicketData): Observable<Ticket> {
    const url = `${this.baseUrl}/tickets/generate`;
    const formData = new FormData();

    formData.append('product_id', ticketData.product_id.toString());
    formData.append('quantity_persons', ticketData.quantity_persons.toString());
    formData.append('payment_status', ticketData.payment_status.toString());
    formData.append('payment_method', ticketData.payment_method.toString());
    formData.append('reference', ticketData.reference ?? '');

    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers => this.http.post<Ticket>(url, formData, { headers }))
    );
  }

}
